import React from 'react';

import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

const ConsentsList = ({ sortedEventConsents }) => {
  const theme = useTheme();
  return (
    <>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
          flexDirection: 'column'
        }}
      >
        {sortedEventConsents?.map((consent, index) => (
          <Box
            key={`${sortedEventConsents?.id}-${index}`}
            sx={{
              width: '100%',
              padding: 1,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-start'
            }}
          >
            <Box
              sx={{
                width: 24,
                height: 24,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              {consent.isChecked ? (
                <CheckBoxIcon sx={{ color: theme?.palette?.booking?.checkBox, marginRight: 1 }} />
              ) : (
                <CheckBoxOutlineBlankIcon
                  sx={{ color: theme?.palette?.grey?.[300], marginRight: 1 }}
                />
              )}
            </Box>
            <Typography variant='body2'>{`${consent?.name}${consent?.mandatory ? ' *' : ''}`}</Typography>
          </Box>
        ))}
      </Box>
    </>
  );
};

export default ConsentsList;
